
    import Vue from 'vue';
import { ChevronRightIcon } from 'vue-feather-icons'
    export default Vue.extend({
        name: 'RomaBreadcrumbs',
        props: {
            title: {
                type: String,
                default: ''
            },
            tabs: {
              type: Array,
            },
            tab: {
                type: String,
            }
        },
        data() {
            return {
                acitvedTab: this.tab,
            };
        },
        computed: {
            breadcrumbs () {
                let breadcrumbs = [];

                breadcrumbs = this.$route.matched.map(
                    route => {
                        if (route.meta && route.meta.text) {
                            const href = route.name === 'home' ? '/' : route.path;
                            const text = route.meta.idInText && (this.$route.params && this.$route.params.id)
                              ? this.$vuetify.lang.t(`$vuetify.component.romaBreadCrumbs.${route.meta.text}`) + ' ' + this.$route.params.id
                              : this.$vuetify.lang.t(`$vuetify.component.romaBreadCrumbs.${route.meta.text}`);
                            return {
                              text,
                              disabled: route.name === this.$route.name, href: href, // Corrección temporal o final depende funcionamiento futuro
                            };
                        }
                    }
                );

                if (this.tab && this.tabs && this.$route.hash) {
                    const index = this.acitvedTab.slice(this.acitvedTab.length-1, this.acitvedTab.length);
                    breadcrumbs.push({text: this.$vuetify.lang.t(`$vuetify.component.unit.${this.tabs[index].label}`), disabled: true, path: 'test'})
                }

                return breadcrumbs;
            }
        },
        watch: {
          tab (value) {
              this.acitvedTab = value;
          }
        },
        components: {
          ChevronRightIcon
        }
    });
